
(function() {
  var result = { translations: { "pt-pt": { "i18n": { "duration": { "seconds": "{{ seconds }} seg.", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} de {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pt-pt": "static-7.1167"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1167",
    "ar-eg": "static-7.1167",
    "bg": "static-7.1167",
    "bn": "static-7.1167",
    "ca-es": "static-7.1167",
    "cs": "static-7.1167",
    "da": "static-7.1167",
    "de": "static-7.1167",
    "el": "static-7.1167",
    "en-gb": "static-7.1167",
    "en": "static-7.1167",
    "es-mx": "static-7.1167",
    "es": "static-7.1167",
    "et": "static-7.1167",
    "fi": "static-7.1167",
    "fr-ca": "static-7.1167",
    "fr": "static-7.1167",
    "he-il": "static-7.1167",
    "hi": "static-7.1167",
    "hr": "static-7.1167",
    "hu": "static-7.1167",
    "id": "static-7.1167",
    "it": "static-7.1167",
    "ja": "static-7.1167",
    "ko": "static-7.1167",
    "lt": "static-7.1167",
    "ms": "static-7.1167",
    "nl": "static-7.1167",
    "no": "static-7.1167",
    "pl": "static-7.1167",
    "pt-br": "static-7.1167",
    "pt-pt": "static-7.1167",
    "ro": "static-7.1167",
    "ru": "static-7.1167",
    "sk": "static-7.1167",
    "sl": "static-7.1167",
    "sv": "static-7.1167",
    "th": "static-7.1167",
    "tl": "static-7.1167",
    "tr": "static-7.1167",
    "uk": "static-7.1167",
    "vi": "static-7.1167",
    "x-pseudo": "static-7.1167",
    "zh-cn": "static-7.1167",
    "zh-hk": "static-7.1167",
    "zh-tw": "static-7.1167"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-pt', {version: 'static-7.1167'}); }
})();


